<script lang="ts">
    import Modal from "@components/Modal/Modal.svelte";
    import Spinner from "@components/Spinner/Spinner.svelte";

    export let open = false;
</script>

<!-- TODO move light-spinner-color to a variable -->
<Modal {open} style="--gw-spinner-color:#fff;" responsive={false}>
    <Spinner />
</Modal>
